/**
 * Блокировка прокрутки страницы под открытым окном.
 *
 * `overflow: hidden` на body телефоны (особенно iPhone) игнорируют — страница под окном продолжает крутиться.
 * Поэтому фиксируем body на текущей позиции, а при закрытии возвращаем прокрутку туда же.
 * Окно при этом прокручивается само, если ему не хватает высоты.
 */
let lockedY: number | null = null;

export function lockPageScroll(): void {
  if (lockedY !== null) return;
  const body = document.body;
  const scrollbar = window.innerWidth - document.documentElement.clientWidth;
  lockedY = window.scrollY;
  document.documentElement.style.overflow = 'hidden';
  body.style.position = 'fixed';
  body.style.top = `-${lockedY}px`;
  body.style.left = '0';
  body.style.right = '0';
  body.style.width = '100%';
  body.style.overflow = 'hidden';
  if (scrollbar > 0) body.style.paddingRight = scrollbar + 'px';
}

export function unlockPageScroll(): void {
  if (lockedY === null) return;
  const y = lockedY;
  lockedY = null;
  const body = document.body;
  document.documentElement.style.overflow = '';
  body.style.position = '';
  body.style.top = '';
  body.style.left = '';
  body.style.right = '';
  body.style.width = '';
  body.style.overflow = '';
  body.style.paddingRight = '';
  window.scrollTo({ top: y, behavior: 'instant' as ScrollBehavior });
}
